import { render, staticRenderFns } from "./UsersSetting.vue?vue&type=template&id=03f3911f"
import script from "./UsersSetting.vue?vue&type=script&lang=js"
export * from "./UsersSetting.vue?vue&type=script&lang=js"
import style0 from "./UsersSetting.vue?vue&type=style&index=0&id=03f3911f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports